export const selectNotificationItems = (state) =>
  state.notifications?.items ?? [];

export const selectNotificationListLoading = (state) =>
  Boolean(state.notifications?.loading);

export const selectNotificationListLoadingMore = (state) =>
  Boolean(state.notifications?.loadingMore);

export const selectNotificationListError = (state) =>
  state.notifications?.error;

export const selectNotificationLoadMoreError = (state) =>
  state.notifications?.loadMoreError;

export const selectNotificationListLoaded = (state) =>
  Boolean(state.notifications?.success);

export const selectNotificationFilter = (state) =>
  state.notifications?.filter ?? "all";

export const selectNotificationHasNextPage = (state) =>
  Boolean(state.notifications?.next);

export const selectNotificationUnreadCount = (state) =>
  Number(state.notifications?.unreadCount) || 0;

export const selectIsMarkingRead = (id) => (state) =>
  Boolean(state.notifications?.markingIds?.[id]);

export const selectMarkReadError = (state) =>
  state.notifications?.markReadError;

export const selectMarkAllLoading = (state) =>
  Boolean(state.notifications?.markAllLoading);

export const selectMarkAllError = (state) =>
  state.notifications?.markAllError;
